<template>
  <div class="search">
    <div class="searchContent">
      <div class="title-flex">
        <h3 class="title">结料明细</h3>
        <div class="select-title">
          <div class="invalidGoods" v-if="allRemaining">网点余料：{{ allRemaining }}g</div>
          <div class="searchInput_child">
            <div class="order-title">网点筛选：</div>
            <div class="orderSearch">
              <div class="networkWrap">
                <el-select v-model="sitekey" placeholder="请选择网点" filterable clearable @change="onChange">
                  <!-- <el-option label="全部" value="" /> -->
                  <el-option v-for="item in networkList" :key="item.orgCode" :label="item.label" :value="item.orgCode"> </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="angle">
        <div
          v-for="(item, index) in CommodityArr"
          :key="index"
          v-if="
            (item.title === '全部' || item.title === '待支付' || item.title === '配货中' || item.title === '已出货') &&
            hasMainBodyType()[0].value === '2'
          "
        >
          <el-badge :value="item.badge" class="item">
            <span @click="getTitle(index, item)" :class="index === activeIndex ? 'isActive' : ''">{{ item.title }}</span>
          </el-badge>
        </div>
        <div v-for="(item, index) in CommodityArr" :key="index" v-if="hasMainBodyType()[0].value !== '2'">
          <el-badge :value="item.badge" class="item">
            <span @click="getTitle(index, item)" :class="index === activeIndex ? 'isActive' : ''">{{ item.title }}</span>
          </el-badge>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getGoldMaterialNetworkList } from '@/api/cartApi';
import ls from '@/utils/localStorage';
import store from '@/store';
export default {
  name: 'Search',
  props: {
    CommodityArr: {
      type: Array,
      default() {
        return [];
      },
    },
    allRemaining: {
      type: String,
      default() {
        return '0';
      },
    },
  },
  data() {
    return {
      listQuery: {
        siteId: '',
      },
      badge: {},
      activeIndex: 0,
      status: '',
      userInfo: {},
      networkList: [],
      sitekey: '',
      searchCondition: {
        orgCode: '',
      },
    };
  },

  mounted() {
    // this.listQuery.siteId = ls.get('siteId') || ls.get('userInfo').comOrganization?.id || 0;
    // this.listQuery.orgCode = ls.get('userInfo').comOrganization?.orgCode ? ls.get('userInfo').comOrganization?.orgCode : 0;
    this.userInfo = ls.get('userInfo');
    this.fetchNetworkList();
  },
  methods: {
    onChange(value) {
      if (!value) {
        this.listQuery.siteId = '';
        this.searchCondition.orgCode = '';
        this.$emit('searchOrder', this.searchCondition, this.status);
        return;
      }
      this.searchCondition.orgCode = value;
      // if (this.listQuery.siteId != value) {
      //   this.listQuery.siteId = value;
      //   this.networkList.forEach((ely) => {
      //     if (ls.get('siteId') == ely.siteId) {
      //       this.searchCondition.orgCode = ely.orgCode;
      this.$emit('searchOrder', this.searchCondition, this.status);
      //     }
      //   });
      // }
    },
    // 获取所有网点
    fetchNetworkList() {
      const params = {
        type: 1, // 获取不要机构的网点接口, type=1
        isAllNetwork: false, // true公司下的所有网点 false当前账号的所有网点
        isHead: false, // 周六福总部 true显示 false不显示
        typeList: 'S',
        status: 'o',
        size: 200,
        current: 1,
      };
      getGoldMaterialNetworkList(params).then((res) => {
        res.data?.forEach((item) => {
          const obj = {
            siteId: item.id,
            orgCode: item.orgCode,
            frontName: item.shortName || item.orgName,
            label: `[${item.orgCode}]${item.shortName || item.orgName}`,
          };
          this.networkList.push(obj);
        });
        // if (this.networkList[0]) {
        //   this.searchCondition.orgCode = this.networkList[0]?.orgCode;
        //   this.sitekey = this.networkList[0]?.label;
        //   this.$emit('searchOrder', this.searchCondition, this.status);
        // }
        // if (
        //   this.networkList.findIndex((item) => item.siteId == ls.get('userInfo').comOrganization?.id) === -1 &&
        //   ls.get('userInfo').comOrganization?.id
        // ) {
        //   this.networkList.unshift({
        //     siteId: ls.get('userInfo').comOrganization?.id,
        //     orgCode: ls.get('userInfo').comOrganization?.orgCode,
        //     frontName: ls.get('userInfo').comOrganization?.shortName || ls.get('userInfo').comOrganization?.orgName,
        //     label: `[${ls.get('userInfo').comOrganization?.orgCode}]${
        //       ls.get('userInfo').comOrganization?.shortName || ls.get('userInfo').comOrganization?.orgName
        //     }`,
        //   });
        // }
      });
    },
    // 点击title元素显示选中效果
    getTitle(i, e) {
      this.activeIndex = i;
      this.status = e.status;
      this.$emit('searchOrder', this.searchCondition, e.status);
    },
    // 跳转预售订单
    goLoseEffectiveness() {
      this.$router.push({ path: './PresellOrder' });
    },
  },
};
</script>

<style scoped lang="scss">
.search {
  .searchContent {
    max-width: 1500px;
    margin: 0 auto;
    .title-flex {
      margin-top: 20px;
    }
    .select-title {
      display: flex;
      align-items: center;
      margin: 20px 0;
    }
    .title {
      font-size: 28px;
      font-weight: 500;
      line-height: 33.6px;
    }

    .searchInput {
      display: flex;
      align-items: center;
      margin-top: 20px;
    }

    .searchInput_child {
      display: flex;
      align-items: center;
      font-size: 14px;
    }

    /deep/ .searchInput .el-button:hover {
      border-radius: none;
      border: 1px solid #ec9368;
      background: #ec9368;
      color: #fff;
    }

    /deep/ .searchInput .el-button:focus {
      background: #ec9368;
      border: 1px solid #ec9368;
      color: #fff;
    }

    /deep/ .searchInput .el-button {
      width: 70px;
      padding: 0;
      color: #fff;
      background: #ec9368;
      display: inline-block;
      height: 35px;
      border-radius: none;
      font-size: 14px;
    }

    .angle {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 30px 0 30px 0;
    }

    .angle div {
      display: inline-block;
      cursor: pointer;
      margin-right: 30px;
    }

    .isActive {
      color: #ed9970;
    }

    /deep/ .orderSearch .el-input__inner {
      border-radius: 24px !important;
      border: 1px solid #ec9368 !important;
    }

    /deep/ .orderSearch .el-input__inner {
      border-radius: 24px !important;
      height: 35px !important;
      line-height: 35px !important;
    }

    .order-title {
      margin-left: 30px;
    }
  }
  .invalidGoods {
    font-size: 20px;
    font-weight: 500;
  }
}
</style>
